import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import KontaktHeader from '../components/Kontakt/KontaktHeader';
import KontaktFormArea from '../components/Kontakt/KontaktFormArea';
import KontaktExtendedInfo from '../components/Kontakt/KontaktExtendedInfo';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const Kontakt = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('contact_page_title')}
                description={t('contact_page_description')}
                canonical={`${baseUrl}/kontakt/`}
                openGraph={{
                    url: `${baseUrl}/kontakt/`,
                    title: t('contact_page_ogTitle'),
                    description: t('contact_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('contact_page_ogImageAlt'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('contact_page_ogSiteName'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow',
                    },
                    {
                        name: 'keywords',
                        content: t('contact_page_keywords'),
                    },
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/kontakt/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/kontakt/'
                    }
                ]}
            />
            <Navbar />
            <KontaktHeader />
            <KontaktExtendedInfo />
            <KontaktFormArea />
            <Footer />
        </>
    );
}
export default Kontakt;